import React, { useState, useContext, useRef, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { SearchContext } from '../Contexts';
import useOutsideAlerter from '../hooks/useOutsideClick';

const DateRange = ({ dateRangeLabel }) => {
  const { dateRange, setDateRange, years, dropdownValue, setDropdownValue} =
    useContext(SearchContext);
  const [fromYears, setFromYears] = useState(years.sort().reverse());
  const [toYears, setToYears] = useState(years.sort().reverse());

  return (
    <div className="advanced-search__date-range">
      {dateRangeLabel ? (
        <label className="advanced-search__date-range-title">
          {dateRangeLabel}
        </label>
      ) : (
        ''
      )}
      <div className="advanced-search__date-range-container">
        {dateRange && dateRange.length
          ? dateRange.map((range, i) => {
              const [isOpen, setIsOpen] = useState(false);
              const dropdownRef = useRef(null);

              const handleDateRange = e => {
                const clone = [...dropdownValue];
                const cloneDate = [...dateRange];

                clone[i] = e.target.innerText;
                cloneDate[i].value = e.target.innerText;
                setDropdownValue(clone);
                setDateRange(cloneDate);
              };

              useEffect(() => {
                if (range.label === 'From') {
                  const y = years.filter(x => {
                    if (dropdownValue[i] && x >= dropdownValue[i]) {
                      return x;
                    }
                  });
                  setToYears(y.length ? y : years);
                }

                if (range.label === 'To') {
                  const y = years.filter(x => {
                    if (dropdownValue[i] && x <= dropdownValue[i]) {
                      return x;
                    }
                  });
                  setFromYears(y.length ? y : years);
                }
              }, [isOpen]);

              useOutsideAlerter(dropdownRef, setIsOpen);
              return (
                <div className="advanced-search__date-range-wrapper" key={i}>
                  <label className="advanced-search__date-range-label">
                    {range.label}
                  </label>
                  <div
                    className="advanced-search__date-range-dropdown-container"
                    aria-expanded={isOpen}
                    onClick={() => setIsOpen(!isOpen)}
                    ref={dropdownRef}
                  >
                    <label className="advanced-search__date-range-placeholder">
                      {dropdownValue[i] || range.placeholder}
                    </label>
                    <div className="advanced-search__date-range-dropdown">
                      {range.label === 'From' &&
                        fromYears &&
                        fromYears.length &&
                        fromYears.map((year, index) => (
                          <label key={index} onClick={e => handleDateRange(e)}>
                            {year}
                          </label>
                        ))}
                      {range.label === 'To' &&
                        toYears &&
                        toYears.length &&
                        toYears.map((year, index) => (
                          <label key={index} onClick={e => handleDateRange(e)}>
                            {year}
                          </label>
                        ))}
                    </div>
                  </div>
                </div>
              );
            })
          : ''}
      </div>
    </div>
  );
};

DateRange.propTypes = {
  dateRangeLabel: PropTypes.string
};

export default DateRange;
